/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommandSuccessViewModel } from '../models/CommandSuccessViewModel';
import type { CreatePromotionGroupCommand } from '../models/CreatePromotionGroupCommand';
import type { PromotionGroupViewModel } from '../models/PromotionGroupViewModel';
import type { ReorderPromotionGroupsCommand } from '../models/ReorderPromotionGroupsCommand';
import type { UpdatePromotionGroupBusinessesCommand } from '../models/UpdatePromotionGroupBusinessesCommand';
import type { UpdatePromotionGroupCommand } from '../models/UpdatePromotionGroupCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PromotionGroupsAdminService {
    /**
     * @returns PromotionGroupViewModel Success
     * @throws ApiError
     */
    public static getApiPromotionGroupsAdmin(): CancelablePromise<Array<PromotionGroupViewModel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/promotion-groups-admin',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PromotionGroupViewModel Success
     * @throws ApiError
     */
    public static postApiPromotionGroupsAdmin(
        requestBody?: CreatePromotionGroupCommand,
    ): CancelablePromise<PromotionGroupViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/promotion-groups-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns PromotionGroupViewModel Success
     * @throws ApiError
     */
    public static getApiPromotionGroupsAdmin1(
        id: string,
    ): CancelablePromise<PromotionGroupViewModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/promotion-groups-admin/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns PromotionGroupViewModel Success
     * @throws ApiError
     */
    public static putApiPromotionGroupsAdmin(
        id: string,
        requestBody?: UpdatePromotionGroupCommand,
    ): CancelablePromise<PromotionGroupViewModel> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/promotion-groups-admin/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static deleteApiPromotionGroupsAdmin(
        id: string,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/promotion-groups-admin/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PromotionGroupViewModel Success
     * @throws ApiError
     */
    public static putApiPromotionGroupsAdminReorder(
        requestBody?: ReorderPromotionGroupsCommand,
    ): CancelablePromise<Array<PromotionGroupViewModel>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/promotion-groups-admin/reorder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns PromotionGroupViewModel Success
     * @throws ApiError
     */
    public static putApiPromotionGroupsAdminBusinesses(
        id: string,
        requestBody?: UpdatePromotionGroupBusinessesCommand,
    ): CancelablePromise<PromotionGroupViewModel> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/promotion-groups-admin/{id}/businesses',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns PromotionGroupViewModel Success
     * @throws ApiError
     */
    public static postApiPromotionGroupsAdminEnsureSpecialGroups(): CancelablePromise<Array<PromotionGroupViewModel>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/promotion-groups-admin/ensure-special-groups',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
